import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import UserOverview from "./detail/UserOverview";
import CourseList from "./detail/CourseList";
import { getSPUserDetail } from "store/thunks";

const LIST_TYPE = [
  { label: "Overview", value: "Overview" },
  { label: "List Course", value: "Courses" },
];

interface UserDetailProps {
  userId: string;
  setLinkImage: any;
  listCountry?: [];
}

const UserDetail = ({
  userId,
  setLinkImage,
  listCountry
}: UserDetailProps) => {
  const { t } = useTranslation();
  const [typeTab, setTypeTab] = useState<string>("Overview");
  const [user, setUser] = useState<any>(null);
  const handleChangeTab = (name: string) => {
    setTypeTab(name);
  };

  useEffect(() => {
    const handleCallCampaignDetail = async () => {
      if (!userId) return;

      try {
        const resDetail: any = await getSPUserDetail(userId);
        if (resDetail?.data) {
          setUser(resDetail?.data);
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallCampaignDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  console.log(user)
  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}>
            <div
              style={{
                background: "#f3f6f9",
                borderTopLeftRadius: "0.6rem",
                borderTopRightRadius: "0.6rem",
                position: "sticky",
                top: "-20px",
                zIndex: 99,
              }}
            >
              <div
                className="d-block"
                style={{
                  background: "#f3f6f9",
                  borderRadius: "0.6rem",
                  width: "fit-content",
                }}
              >
                <Nav tabs className="nav nav-tabs nav-justified">
                  {LIST_TYPE?.map((item) => (
                    <li className="list-inline-item" key={item?.value}>
                      <NavItem>
                        <NavLink
                          style={{
                            cursor: "pointer",
                            background: `${
                              String(typeTab) === String(item?.value)
                                ? "#009ef7"
                                : "unset"
                            }`,
                            color: `${
                              String(typeTab) === String(item?.value)
                                ? "white"
                                : "#009ef7"
                            }`,
                            borderWidth: 0,
                          }}
                          className={
                            String(typeTab) === String(item?.value)
                              ? "bar-detail active"
                              : "bar-detail"
                          }
                          onClick={() => handleChangeTab(item?.value)}
                        >
                          {t(item?.label)}
                        </NavLink>
                      </NavItem>
                    </li>
                  ))}
                </Nav>
              </div>
            </div>

            <TabContent activeTab={typeTab}>
              <TabPane tabId={typeTab} className="position-relative">
                {typeTab === "Overview" && (
                  <UserOverview
                    user={user}
                    setLinkImage={setLinkImage}
                    listCountry={listCountry}
                  />
                )}
                {typeTab === "Courses" && (
                  <CourseList userId={userId} />
                )}
              </TabPane>
            </TabContent>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserDetail;
